<div class="location-map-finder-container">
  <div #gmap class="location-finder-map" [ngClass]="{ 'hide-map': hideMap }"></div>
  <div class="ada-close"></div>
  <div color="primary" id="search-area-button" class="btn-map-locator-area" (click)="showOtherListLocations()">
    <span class="label">{{ labels.locationMaps.searchArea }}</span>
  </div>
  <div color="primary" id="original-address-button" class="btn-map-original-address"
    (click)="showOtherListLocations(originalAddressSearched)">
   <img src="assets\images\map-location\navigation-icon.svg" alt="navigation icon" />
  </div>
  <div class="map-button-items">
    <div color="primary" id="search-area-button" class="btn-map-locator-area-mobile" (click)="showOtherListLocations()">
      <span class="label">{{ labels.locationMaps.searchArea }}</span>
    </div>
    <div color="primary" id="original-address-button" class="btn-map-original-address-mobile"
      (click)="showOtherListLocations(originalAddressSearched)">
     <img src="assets\images\map-location\navigation-icon.svg" alt="navigation icon" />
    </div>
  </div>
</div>